import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  surface?: "base" | "raised" | "transparent";
  ring?: boolean;
  children?: ReactNode;
}

export function Card({
  className,
  surface = "base",
  ring = false,
  children,
  ...rest
}: CardProps) {
  const surfaceClass =
    surface === "base"
      ? "bg-[var(--color-deep-charcoal)]"
      : surface === "raised"
        ? "bg-[var(--color-graphite-700)]"
        : "bg-transparent";

  return (
    <div
      className={cn(
        "rounded-[var(--radius-card)] p-6",
        surfaceClass,
        ring ? "shadow-ring" : "shadow-hairline",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
